import React from 'react'
import ProductHistoryList from '../../product/ProductHistoryList'

export default function UserProductHistory({ user }) {
  return <ProductHistoryList user={user} />
}
